import type { Marketplace } from '@/store/organization/projectSlice';
import type {
  IChartCardDefaultItem,
  ILineTimeItemData,
  IResponseTypeLineItem,
  IResponseTypeScatterItem,
} from './response-types';

export type IMarketplaceDropDown = {
  [key in Marketplace]: {
    title: string;
    icon: string;
  };
};

export type IChartCard = IResponseTypeScatterItem | IResponseTypeLineItem;

export enum ChartsTypeEnum {
  scatter = 'scatter',
  line = 'line',
  barStack = 'barStack',
  treeMap = 'treemap',
}

export type IScatterConfigItem = {
  name: string;
  symbolSize: number;
  originalSymbolSize: number;
  value: [number, number];
};

export type ILineConfigItem = {
  brand: string;
  yValue: number;
  date: string;
};

export type ITreeMapConfigItem = {
  name: string;
  sizeValue: number;
  colorValue: number;
};

export type IChartLabels = {
  x: string;
  y: string;
};

export type ITableData = {
  tableHeaders: string[];
  tableData: (string | number)[][];
};

export type IResponseAllAndAdsData<T> = {
  all: T;
  ads: T;
  brands?: string[];
};

export type ILineProgressMap = {
  [key in ChartsTypeEnum]?: ILineTimeItemData[];
};

export type ICommonChartCard = IChartCard[] | IChartCardDefaultItem[];

export type IOnlyMyBrandsMap = { [key: string]: string };

export {
  type IChartCardDefaultItem,
  type ISoiScatterItem,
  type ISopScatterItem,
  type IResponseTypeLineItem,
  type IResponseTypeScatterItem,
  type IScatterChartTab,
  type ILineTimeItemData,
  type ILineItemData,
  type IChartTab,
} from './response-types';
